// Presentation-only date formatter shared by Iran review and audit UI.
// Keep API/database timestamps unchanged; display them in Tehran time.
const dateTimeFormatter = new Intl.DateTimeFormat("fa-IR-u-ca-persian-nu-arabext", {
  timeZone: "Asia/Tehran", year: "numeric", month: "2-digit",
  day: "2-digit", hour: "2-digit", minute: "2-digit", hourCycle: "h23",
});
const dateFormatter = new Intl.DateTimeFormat("fa-IR-u-ca-persian-nu-arabext", {
  timeZone: "UTC", year: "numeric", month: "2-digit", day: "2-digit",
});

function formatParts(formatter, date, withTime) {
  const parts = Object.fromEntries(formatter.formatToParts(date).map(p => [p.type, p.value]));
  const day = `${parts.year}/${parts.month}/${parts.day}`;
  return withTime ? `${day} · ${parts.hour}:${parts.minute}` : day;
}

export function formatIranSubmissionTimestamp(value) {
  if (value == null || value === "") return "—";
  // A date-only fallback (a.date) is not a timestamp: avoid inventing 03:30.
  if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const date = new Date(`${value}T00:00:00.000Z`);
    return Number.isFinite(date.getTime()) && date.toISOString().slice(0, 10) === value
      ? formatParts(dateFormatter, date, false) : "—";
  }
  const date = new Date(value);
  if (!Number.isFinite(date.getTime())) return "—";
  return formatParts(dateTimeFormatter, date, true);
}
